import { put, takeEvery } from "@redux-saga/core/effects";
import {
	handleNotificationAlertCatch,
	handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import AxiosCustom from "../../../common/components/apiConfig";

export const actionTypes = {
	seleCreditRelatedStatisticsTable: "[selectCreditRelatedStatistics ] Action",
	selectCreditRelatedStatisticsLoad:
		"[selectCreditRelatedStatisticsLoad] Action",
	selectCreditRelatedStatisticsAsync:
		"[selectCreditRelatedStatisticsAsync] Action",
};

const initialState = {
	data: [],
	
	loading: false,
};

export const select_credit_related_statistics_reducer = (
	state = initialState,
	{ type, payload },
) => {
	switch (type) {
		case actionTypes.seleCreditRelatedStatisticsTable:
			return {
				...state,
				data: payload?.data?.results ? payload?.data?.results : [],
			};

		case actionTypes.selectCreditRelatedStatisticsLoad:
			return {
				...state,
				loading: payload,
			};
		default:
			return state;
	}
};

function* handleWorker({ payload }) {
	yield put({
		type: actionTypes.selectCreditRelatedStatisticsLoad,
		payload: payload,
	});
	let config = {
		url: "select_request",
	};

	let data = {
		table: "credit",
		method_type: "select_credit_related_statistics",
		data: payload?.data ? payload?.data : {},
		sort_by: {},
		size: "50",
		from: "0",
	};

	try {
		let res = yield AxiosCustom(config, data);
		let isOk = handleNotificationAlertTrySelect(res);
		yield put({
			type: actionTypes.seleCreditRelatedStatisticsTable,
			payload: res.data.response,
		});
	} catch {
		handleNotificationAlertCatch();
		// yield put({ type: actionTypes.creaditSelectLoad, payload: false });
	} finally {
		yield put({
			type: actionTypes.selectCreditRelatedStatisticsLoad,
			payload: false,
		});
	}
}

export function* selectCreditRelatedStatistics() {
	yield takeEvery(actionTypes.selectCreditRelatedStatisticsAsync, handleWorker);
}
